// extracted by mini-css-extract-plugin
export const body = "PortExcursionModal-module--body--3CPk1";
export const image = "PortExcursionModal-module--image--1yXbc";
export const content = "PortExcursionModal-module--content--3dtql";
export const icons = "PortExcursionModal-module--icons--3wRph";
export const iconsRow = "PortExcursionModal-module--icons-row--1hb9o";
export const activityLevelAlignFix = "PortExcursionModal-module--activity-level-align-fix--fA-wR";